import { atomFamily, atomWithStorage } from "jotai/utils";
import { useAtom } from "jotai";
import Storage from "./Storage";

const atomStorage = {
    getItem: (key: string) => {
        const value = Storage.get<string>(key);
        if (value === null) throw new Error();
        return value;
    },
    setItem: (key: string, val: any) => Storage.set(key, val),
    removeItem: (key: string) => Storage.remove(key)
};

export const storageAtom = atomFamily(
    ({ key, initialValue }: { key: string; initialValue: string }) =>
        atomWithStorage(key, initialValue, atomStorage),
    (arg1, arg2) => arg1.key === arg2.key
);

export default function useStorage<T>(key: string, initialValue?: string) {
    return useAtom(storageAtom({ key, initialValue: initialValue || "" }));
}
